const currentAreaName = ref<string>();
const additional = ref<string[]>([]);

export const useBodyClasses = () => {
    const headControl = useHead();

    watchEffect(() => {
        const classes = [...new Set([...additional.value, currentAreaName.value || ''])];
        headControl.patch({
            bodyAttrs: {
                class: classes,
                // set default background
                style: 'background-image: revert-layer; background-color: revert-layer;',
                tagDuplicateStrategy: 'replace',
            },
        });
    });

    const areaName = (areaName: string) => {
        currentAreaName.value = areaName;
    };

    const addClasses = (additionalClasses: string[]) => {
        additional.value = additionalClasses;
    };

    return { areaName, addClasses };
};
